export class SurveyInvitation {
    constructor(_data) {
        var _a;
        this.id = _data.id || 0;
        this.survey_id = _data.survey_id || 0;
        this.token = _data.token || '';
        this.email = _data.email || '';
        this.sent = (_a = _data.sent) !== null && _a !== void 0 ? _a : false;
    }
}
